import React from 'react';
import { apiFetch } from '../shared/api/client';
import { dateTime, platformName } from './MeasurementOverview';

const LABELS = {
  plan_limit: 'Лимиты тарифа',
  user_canceled: 'Остановки пользователем',
  context_limit: 'Ограничения контекста',
  technical_error: 'Технические ошибки',
  unclassified: 'Нерасшифрованные причины',
};
export default function ChatOutcomesPanel({ days = 7, revision = 0 }) {
  const [platform, setPlatform] = React.useState('');
  const [state, setState] = React.useState({ loading: true });
  const key = `${days}:${revision}:${platform}`;
  React.useEffect(() => {
    let canceled = false;
    setState({ key, loading: true });
    (async () => {
      try {
        const response = await apiFetch(`/measurement/chat-outcomes?days=${days}${platform ? `&platform=${platform}` : ''}`, { suppressAuthError: true, timeoutMs: 15000 });
        if (!response.ok) throw new Error('unavailable');
        const data = await response.json();
        const counts = ['events', 'accounts', 'recorded', 'without_classification', 'raw_failed', 'raw_canceled'];
        if (!data.reconciled || !Array.isArray(data.rows) || data.rows.length !== 5 ||
            !counts.every(name => Number.isInteger(data.totals?.[name]) && data.totals[name] >= 0) ||
            !Object.keys(LABELS).every(name => data.rows.some(row => row.category === name &&
              Number.isInteger(row.events) && row.events >= 0 && Number.isInteger(row.accounts) && row.accounts >= 0))) {
          throw new Error('invalid_report');
        }
        if (!canceled) setState({ key, data });
      } catch {
        if (!canceled) setState({ key, error: true });
      }
    })();
    return () => { canceled = true; };
  }, [days, revision, platform, key]);
  const current = state.key === key ? state : { loading: true };
  const data = current.data;
  return <section className="mw-section" aria-labelledby="chat-outcomes-title">
    <div className="mw-section-heading"><div><h3 id="chat-outcomes-title">Причины незавершённых ответов</h3>
      <p className="mw-muted">Лимит или остановка — не обязательно технический сбой. Исходные события сохранены.</p></div>
      <label>Устройство запроса <select aria-label="Устройство запроса" value={platform} onChange={event => setPlatform(event.target.value)}>
        {['', 'web', 'ios', 'android', 'unknown'].map(p => <option key={p} value={p}>{p ? platformName(p) : 'Все устройства'}</option>)}
      </select></label></div>
    {current.loading && <p role="status">Загружаем причины…</p>}
    {current.error && <p className="mw-notice" role="alert">Причины сейчас недоступны. Это не означает отсутствие ошибок.</p>}
    {data && <>
      <p className="mw-muted">Период: {dateTime(data.from_utc)} — {dateTime(data.to_utc)} МСК · последние {days} дней до момента расчёта, включая неполный текущий день.</p>
      <p>Исходные failed: <strong>{data.totals.raw_failed}</strong> · canceled: <strong>{data.totals.raw_canceled}</strong> · уникальных затронутых аккаунтов: <strong>{data.totals.accounts}</strong>.</p>
      <div className="mw-table-scroll" tabIndex={0} role="region" aria-label="Причины незавершённых ответов"><table className="mw-table">
        <thead><tr><th scope="col">Причина</th><th scope="col">События</th><th scope="col">Аккаунты</th></tr></thead>
        <tbody>{data.rows.map(row => <tr key={row.category}><th scope="row">{LABELS[row.category]}</th><td>{row.events}</td><td>{row.accounts}</td></tr>)}</tbody>
      </table></div>
      <p className="mw-footnote">Аккаунты между строками пересекаются: их нельзя суммировать. Покрытие — серверные события live-чата; это не полный отчёт по Noesa Code и Telegram.</p>
      {data.totals.without_classification > 0 && <p className="mw-notice">Без сохранённой классификации: {data.totals.without_classification} событий — включены в нерасшифрованные. История до обновления не переписана.</p>}
      <p className="mw-muted">С категорией в журнале: {data.totals.recorded} из {data.totals.events}.{data.totals.first_classified_at_in_window ? ` Первое такое событие в этом окне: ${dateTime(data.totals.first_classified_at_in_window)} МСК.` : ' В этом окне ещё нет событий с новой классификацией.'}</p>
      <details className="mw-disclosure"><summary>Как различаются причины</summary>
        <p>Лимиты тарифа и ограничения контекста определяются по проверенным кодам. Штатная отмена требует признака отмены без ошибки. Противоречивые признаки остаются нерасшифрованными.</p>
        <p>Общий service_unavailable, неизвестный код или отсутствующая причина не доказывают технический сбой. Конкретный технический код описывает симптом, но сам по себе не доказывает неисправность провайдера.</p>
        <p>Завершённые ответы и принятые запросы учитываются отдельно в использовании. Эта разбивка не измеряет удержание или полезность ответа.</p>
      </details>
    </>}
  </section>;
}



